import {Component, Injector} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {getTranslation} from 'shared/helpers/get-translation';

import {QuestionPage} from '../../components/question-page/question-page';
import {Slider, SliderKeypoint} from '../../model/model';
import { NavService } from 'shared/nav/nav.service';

interface TranslatedKeypoint {
  title: string;
  value: number;
}

@Component({
  selector: 'slider-page',
  templateUrl: 'slider-page.html',
  styleUrls: ['slider-page.scss'],
  host: { '[class]': '"ion-page can-go-back"' },
})
export class SliderPage extends QuestionPage {

  public value: number = 50;
  private keyPoints: Array<TranslatedKeypoint>;
  private isSnapping: boolean;
  public minLabel: string;
  public maxLabel: string;

  public get valueLabel(): string {
    const keypoint: TranslatedKeypoint = this.findKeypoint(this.value);
    if (keypoint) {
      return keypoint.title;
    }

    return '';
  }

  constructor(
    private translateService: TranslateService,
    private injector: Injector,
    public navService: NavService,
  ) {
    super(injector, navService);

    const slider: Slider = <Slider> this.question.type;

    this.keyPoints = slider.keyPoints
      .map((keypoint: SliderKeypoint) => {
        const title: string = getTranslation(keypoint.title, this.translateService);
        return { value: keypoint.value, title: title };
      })
      .sort((keypoint1: TranslatedKeypoint, keypoint2: TranslatedKeypoint) => { return keypoint1.value - keypoint2.value; });
    this.isSnapping = slider.isSnapping;
    this.minLabel = getTranslation(slider.minText, this.translateService);
    this.maxLabel = getTranslation(slider.maxText, this.translateService);
  }

  public onNextClick(): void {
    const keypoint: TranslatedKeypoint = this.findKeypoint(this.value);
    if (keypoint) {
      this.answerSelected.emit(this.keyPoints.indexOf(keypoint));
    }
  }

  private findKeypoint(value: number): TranslatedKeypoint {
    const nextIndex: number = this.keyPoints.findIndex((keypoint) => { return keypoint.value > value; });
    if (nextIndex < 1) {
      return this.keyPoints[this.keyPoints.length - 1];
    }

    return this.keyPoints[nextIndex - 1];
  }
}
